import React, { useState, useEffect } from "react";
import Feedback01 from "./Feedback01";
import Feedback02 from "./Feedback02";
import Feedback03 from "./Feedback03";
import useFetch from "../../hooks/useFetch";
import { ReactComponent as Cross } from "../../assets/images/svg/Cross.svg";
import { FEEDBACK } from "../../utils/ApiUrls";
import { TopDisappearingMessage } from "../../utils/Common";
import useAuth from "../../hooks/useAuth";
import useSocket from "../../hooks/useWebsocket";

const STEPS = [
  { key: "Feedback01", label: "Customer Info" },
  { key: "Feedback02", label: "Feedback" },
  { key: "Feedback03", label: "Follow-up" },
];

const CallFeedback = (props) => {
  const [curfback, setcurrfback] = useState("Feedback01");
  const FBdata = props.FBdata;
  const setFBdata = props.setFBdata;
  const fetchData = useFetch();
  const { auth } = useAuth();
  const [isReady, val, send] = useSocket();
  const [editfbpermission, seteditfbpermission] = useState(false);
  console.log("Feedback js   customer data    :    ", props.customer);

  useEffect(() => {
    setcurrfback("Feedback01");
  }, [props.call_id]);

  useEffect(() => {
    if (auth?.user_details?.type === "agent") {
      seteditfbpermission(true);
    } else {
      seteditfbpermission(true);
    }
  }, []);

  useEffect(() => {
    const data = val?.data || { callstatus: "" };
    const action = val?.action;
    console.log("Feedback Value ---->  : ", val)
    console.log("Feedback Data ---->  : ", data)
    console.log(
      typeof data.closeInSeconds,
      "Feedback Hide Tiem --------------------------------->   : ",
      data.closeInSeconds
    );
    if (props.camp_data.campaign_mode == "auto") {
      if (data.callstatus == "end") {
        TopDisappearingMessage(
          "top-start",
          data.closeInSeconds,
          "warning",
          "Next customer in " + data.closeInSeconds + " seconds"
        );

        // setTimeout(function () {
        //   // submitData();
        //   props.setfback(false);
        //   console.log("Send socket message next call auto")
        //   send(
        //     JSON.stringify({
        //       type: "feedback_close",
        //       next_call : true,
        //     })
        //   );

        // }, parseInt(data.closeInSeconds) * 1000);
      }
    }
  }, [val]);

  const CloseFB = () => {
    props.setfback(false);
    props.close(false);
  };

  console.log("before submit feedback customer ---------------->  ", props.customer)

  const submitData = async () => {
    console.log(props.customer);
    let user_id;

    props.setfback(false);
    props.close(false);
    if (props.setFeedbackSubmitted != undefined) {
      props.setFeedbackSubmitted(true);
    }

    if (auth?.user_details?.type == "agent") {
      user_id = auth?.user_details?.contact_agent_id || 0;
    } else {
      user_id = props.FBdata.agent_id || 0;
    }
    let customer_data = props.customer

    if (props.customer.id == undefined) {
      customer_data = localStorage.getItem("customer");
    }

    let url = FEEDBACK + user_id + "/" + customer_data.id + "/";

    const payloadToSend = {
      ...FBdata,
      agent_id: user_id,
      customer_id: customer_data.id,
    };

    const res_data = await fetchData("post", payloadToSend, url);
    if (res_data?.data == "success") {
      console.log(props.campaignRepotData, ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      if (props.campaignRepotData != undefined) {
        const updatedData = props.campaignRepotData.map((item) => {
          if (item && props.FBdata && item.call_uid === props.FBdata.uid) {
            return {
              ...item,
              call_feedback:
                item.call_feedback === null ? res_data?.id : item.call_feedback,
            };
          }
          return item;
        });
        props.setCampaignReportData(updatedData);
      }

      setFBdata((prevState) => {
        return { ...prevState, id: res_data?.id };
      });
      if (
        FBdata.dnc &&
        props.camp_data?.campaign_mode === "manual"
      ) {
        setFBdata({
          id: "0",
          uid: "",
          agent_id: "",
          customer_id: "",
          answers: {},
          fbanswer: {},
          comment: "",
          folloup: "",
          dnc: false,
        });

        if (!props.call_id && typeof props.showNextCustomer === "function") {
          props.showNextCustomer(3);
        }
      }
      TopDisappearingMessage(
        "top-start",
        2000,
        "success",
        "Successfully submited the feedback",
        true
      );
    } else {
      alert("Error in Updating the agent status");
    }
  };

  const questionArray = props?.camp_data?.questionArray || [];
  const hasQuestions = questionArray.length > 0;
  const steps = hasQuestions ? STEPS : STEPS.filter((step) => step.key !== "Feedback02");
  const activeStepIndex = steps.findIndex((step) => step.key === curfback);

  return (
    <div
      id="defaultModal"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    >
      <div className="flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
          <h1 className="text-lg font-bold text-gray-900">Call Feedback</h1>
          <div className="flex items-center gap-1">
            <button
              type="button"
              className="flex h-8 w-8 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
              onClick={CloseFB}
              title="Close"
            >
              <Cross className="h-4 w-4" />
            </button>
          </div>
        </div>

        {/* Step indicator */}
        <div className="flex items-center px-6 pt-5">
          {steps.map((step, index) => {
            const isActive = index === activeStepIndex;
            const isComplete = index < activeStepIndex;
            return (
              <div key={step.key} className="flex flex-1 items-center last:flex-none">
                <div className="flex items-center gap-2">
                  <div
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors ${
                      isActive
                        ? "text-white shadow-sm"
                        : isComplete
                        ? "bg-[#6BC698] text-white"
                        : "bg-gray-100 text-gray-400"
                    }`}
                    style={
                      isActive
                        ? {
                            backgroundImage:
                              "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
                          }
                        : undefined
                    }
                  >
                    {index + 1}
                  </div>
                  <span
                    className={`hidden text-xs font-medium sm:block ${
                      isActive ? "text-gray-900" : "text-gray-400"
                    }`}
                  >
                    {step.label}
                  </span>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`mx-3 h-0.5 flex-1 rounded-full ${
                      isComplete ? "bg-[#6BC698]" : "bg-gray-100"
                    }`}
                  />
                )}
              </div>
            );
          })}
        </div>

        {/* Feedback Components */}
        <div className="flex-1 space-y-6 overflow-y-auto px-6 py-6">
          {curfback === "Feedback01" ? (
            <Feedback01
              customer={props.customer}
              setcurrfback={setcurrfback}
              next={hasQuestions ? "Feedback02" : "Feedback03"}
              showCustomerNo={props.showCustomerNo}
            />
          ) : curfback === "Feedback02" && hasQuestions ? (
            <Feedback02
              answers={FBdata.answers}
              setcurrfback={setcurrfback}
              setFBdata={setFBdata}
              questions={questionArray}
              next="Feedback03"
              back="Feedback01"
            />
          ) : (
            <Feedback03
              fbanswer={FBdata.fbanswer}
              submitData={submitData}
              FBdata={FBdata}
              setcurrfback={setcurrfback}
              setFBdata={setFBdata}
              feedback={props?.camp_data?.feedBackLabels || props?.camp_data?.labels || []}
              back={hasQuestions ? "Feedback02" : "Feedback01"}
              editfbpermission={editfbpermission}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(CallFeedback);
